/* ENSO — product lightbox v2 (12 Sep 2026; thumbnail strip added 15 Sep)
   Replaces the section's one-image overlay (#epcLightbox) without editing
   the 94 KB section: a capture-phase click listener on document catches the
   "Explore closer" button and taps on the gallery image before the section's
   own handlers run, and opens this <dialog> instead.
   - loads the 2048px rendition of every slide, not the on-screen 600–1400px file
   - swipe / arrows between slides, "3 / 9" counter; arrows and Left/Right keys
     loop (last -> first, first -> last, with a quick fade; 22 Sep)
   - thumbnail strip along the bottom (.elb__thumbs): tap to jump, active chip ringed,
     strip scrolls to keep the active chip in view; hidden while zoomed
   - tap (or click) the image to zoom to 2.5x at that point, tap again to zoom out
     (22 Sep); pinch zoom; pan when zoomed; swipe down to close when not zoomed
   - backdrop tap, ✕, Escape close; <dialog> handles focus
   - 26 Sep: no blank frame on open/swipe (the gallery's own image shows at once,
     the 2048px file swaps in when it arrives); ✕ and counter sit on a dark disc so
     they stay visible over a zoomed white-background photo
   Styles: assets/enso-pdp-lightbox.css (bundled) + snippets/enso-css-pdp-2.liquid (thumb strip) */
(function () {
  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }
  ready(function () {
    var track = document.getElementById('epcTrack');
    if (!track || !window.HTMLDialogElement) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.epc__slide img'));
    if (!slides.length) return;

    /* ---- build ---- */
    var dlg = document.createElement('dialog');
    dlg.className = 'elb';
    dlg.innerHTML =
      '<button type="button" class="elb__close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="elb__count"><b>1</b> / ' + slides.length + '</div>' +
      '<button type="button" class="elb__arrow elb__arrow--prev" aria-label="Previous image"><svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="elb__arrow elb__arrow--next" aria-label="Next image"><svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<div class="elb__track"></div>' +
      '<p class="elb__hint">Tap or pinch to zoom</p>' +
      '<div class="elb__thumbs" role="tablist" aria-label="Product images"></div>';
    var tr = dlg.querySelector('.elb__track');
    var th = dlg.querySelector('.elb__thumbs');
    slides.forEach(function (img, i) {
      var s = document.createElement('div');
      s.className = 'elb__slide';
      s.innerHTML = '<img alt="" draggable="false">';
      var big = s.querySelector('img');
      big.alt = img.alt || '';
      var base = (img.currentSrc || img.src) || (img.dataset && img.dataset.src) || '';
      big.dataset.src = base.replace(/([?&])width=\d+/, '$1width=2048');
      tr.appendChild(s);
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'elb__thumb'; b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + slides.length);
      b.innerHTML = '<img alt="" draggable="false" loading="lazy">';
      b.querySelector('img').src = base.replace(/([?&])width=\d+/, '$1width=160');
      b.addEventListener('click', function (e) { e.stopPropagation(); goTo(i); });
      th.appendChild(b);
    });
    document.body.appendChild(dlg);
    /* 26 Sep: zoomed in on a white-background photo, the white ✕ and counter
       disappeared and the phone's back gesture (which leaves the site) was the
       only obvious way out. A dark disc keeps them visible on any image. */
    var st = document.createElement('style');
    st.textContent = 'dialog.elb .elb__close{background:rgba(20,19,17,.62)}' +
      'dialog.elb .elb__count{background:rgba(20,19,17,.62);padding:7px 10px;border-radius:999px;top:15px;left:12px}';
    document.head.appendChild(st);
    var count = dlg.querySelector('.elb__count b');
    var imgs = Array.prototype.slice.call(tr.querySelectorAll('img'));
    var thumbs = Array.prototype.slice.call(th.children);
    if (thumbs.length < 2) th.hidden = true;

    /* 26 Sep: a slide used to stay blank until its 2048px file had downloaded
       (~0.5 s on a phone). Show the gallery's own image at once (usually already
       in the browser cache), then swap in the 2048px file when it has arrived. */
    function load(i) {
      [i - 1, i, i + 1].forEach(function (j) {
        var im = imgs[j];
        if (!im || im.dataset.st) return;
        im.dataset.st = '1';
        var lo = slides[j].currentSrc || slides[j].src;
        if (lo) im.src = lo;
        var hi = new Image();
        hi.onload = function () { im.src = hi.src; };
        hi.src = im.dataset.src;
      });
    }
    function index() { return Math.round(tr.scrollLeft / tr.clientWidth); }
    function goTo(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      load(i);
      tr.scrollTo({ left: i * tr.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    }
    /* arrows/keys loop; a wrap (last -> first, first -> last) cross-fades and jumps
       instead of smooth-scrolling back through every slide */
    function step(d) {
      var m = slides.length, i = index(), j = ((i + d) % m + m) % m;
      if (j === i + d || m < 3) { goTo(j); return; }
      load(j);
      tr.style.transition = 'opacity .16s ease'; tr.style.opacity = '0';
      setTimeout(function () {
        goTo(j, true); tr.style.opacity = '';
        setTimeout(function () { tr.style.transition = ''; }, 220);
      }, 160);
    }
    function currentGalleryIndex() { return Math.round(track.scrollLeft / track.clientWidth); }
    function mark(i, instant) {
      count.textContent = i + 1;
      thumbs.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      var b = thumbs[i];
      if (b) {
        var left = b.offsetLeft - (th.clientWidth - b.offsetWidth) / 2;
        th.scrollTo({ left: Math.max(0, left), behavior: instant ? 'auto' : 'smooth' });
      }
    }

    function open() {
      var i = currentGalleryIndex();
      resetZoom();
      dlg.showModal();
      goTo(i, true);
      load(i);
      mark(i, true);
      document.body.classList.add('elb-open');
    }
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () { document.body.classList.remove('elb-open'); resetZoom(); });

    /* ---- intercept the section's triggers ---- */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest('#epcZoom') || (t.tagName === 'IMG' && t.closest('#epcTrack'))) {
        e.stopPropagation(); e.preventDefault(); open();
      }
    }, true);

    dlg.querySelector('.elb__close').addEventListener('click', close);
    dlg.querySelector('.elb__arrow--prev').addEventListener('click', function () { step(-1); });
    dlg.querySelector('.elb__arrow--next').addEventListener('click', function () { step(1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target === tr || e.target.classList.contains('elb__slide')) close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    });
    var scrollT;
    tr.addEventListener('scroll', function () {
      clearTimeout(scrollT);
      scrollT = setTimeout(function () { var i = index(); mark(i); load(i); resetZoom(); }, 80);
    }, { passive: true });

    /* ---- zoom & pan (pointer events) ---- */
    var z = { scale: 1, x: 0, y: 0, el: null };
    var pts = {}, startDist = 0, startScale = 1, panStart = null, swipeStart = null, tap = null, lastToggle = 0;
    function apply() {
      if (!z.el) return;
      z.el.style.transform = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.scale + ')';
      z.el.parentNode.classList.toggle('is-zoomed', z.scale > 1.01);
      tr.classList.toggle('is-locked', z.scale > 1.01);
    }
    function resetZoom() {
      if (z.el) { z.el.style.transform = ''; z.el.parentNode.classList.remove('is-zoomed'); }
      z = { scale: 1, x: 0, y: 0, el: null };
      tr.classList.remove('is-locked');
      dlg.classList.remove('is-zoomed');
    }
    function clamp() {
      var r = z.el.parentNode.getBoundingClientRect();
      var maxX = (r.width * (z.scale - 1)) / 2, maxY = (r.height * (z.scale - 1)) / 2;
      z.x = Math.max(-maxX, Math.min(maxX, z.x));
      z.y = Math.max(-maxY, Math.min(maxY, z.y));
    }
    function zoomTo(scale, cx, cy) {
      var el = imgs[index()];
      if (z.el !== el) { resetZoom(); z.el = el; }
      var r = el.parentNode.getBoundingClientRect();
      var ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2);
      var k = scale / z.scale;
      z.x = ox - k * (ox - z.x); z.y = oy - k * (oy - z.y);
      z.scale = scale;
      if (z.scale <= 1.01) { z.scale = 1; z.x = 0; z.y = 0; }
      clamp(); apply();
      dlg.classList.toggle('is-zoomed', z.scale > 1.01);
    }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }

    tr.addEventListener('pointerdown', function (e) {
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 2) {
        startDist = dist(pts[ids[0]], pts[ids[1]]); startScale = z.scale || 1; panStart = null; tap = null;
      } else if (ids.length === 1) {
        var now = Date.now();
        /* a tap on the image toggles zoom when the finger lifts - see up() */
        tap = e.target && e.target.tagName === 'IMG' ? { x: e.clientX, y: e.clientY, t: now } : null;
        panStart = z.scale > 1.01 ? { x: e.clientX - z.x, y: e.clientY - z.y } : null;
        swipeStart = z.scale > 1.01 ? null : { y: e.clientY, t: now };
      }
    });
    tr.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (ids.length === 2) {
        var d = dist(pts[ids[0]], pts[ids[1]]);
        var cx = (pts[ids[0]].x + pts[ids[1]].x) / 2, cy = (pts[ids[0]].y + pts[ids[1]].y) / 2;
        zoomTo(Math.max(1, Math.min(4, startScale * d / startDist)), cx, cy);
        e.preventDefault();
      } else if (panStart && z.scale > 1.01) {
        z.x = e.clientX - panStart.x; z.y = e.clientY - panStart.y; clamp(); apply();
        e.preventDefault();
      }
    });
    function up(e) {
      delete pts[e.pointerId];
      var left = Object.keys(pts).length, now = Date.now();
      /* 22 Sep: one tap (or click) on the image zooms in at that point and the next
         one zooms back out. Clarity logged single taps on the lightbox image as dead
         clicks (the zoom-in cursor promised it; only a double-tap worked). A double
         tap still gives a single toggle: taps within 350 ms of a toggle are ignored.
         Drags, pans, pinches and swipes move more than 10 px, so they never toggle. */
      if (tap && !left && e.type === 'pointerup' && now - tap.t < 500 &&
          Math.abs(e.clientX - tap.x) < 10 && Math.abs(e.clientY - tap.y) < 10) {
        if (now - lastToggle > 350) { zoomTo(z.scale > 1.01 ? 1 : 2.5, e.clientX, e.clientY); lastToggle = now; }
        swipeStart = null;
      }
      if (swipeStart && !left) {
        var dy = e.clientY - swipeStart.y;
        if (dy > 90 && now - swipeStart.t < 600) close();
      }
      if (!left) { panStart = null; swipeStart = null; tap = null; }
    }
    tr.addEventListener('pointerup', up); tr.addEventListener('pointercancel', up);
    tr.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && z.scale <= 1.01) return;
      e.preventDefault();
      zoomTo(Math.max(1, Math.min(4, z.scale * (e.deltaY < 0 ? 1.15 : 0.87))), e.clientX, e.clientY);
    }, { passive: false });
  });
})();

/* ---------------------------------------------------------------------------
   ENSO — PDP inline gallery fixes (22 Sep 2026). Separate from the lightbox
   above; kept in this file so layout/theme.liquid needs no new script tag.
   1. Thumbnail numbering. sections/enso-pdp-concept.liquid (94 KB, not
      writable) sets each thumbnail's data-go from forloop.index over ALL
      product media, but only images get a slide. On the 7 products with a
      video, every thumbnail after the video pointed one slide ahead, the last
      two opened the same image and the ring landed on the wrong thumbnail
      (Alabaster Globe, antique brass: click 7, ring on 6). Renumbered 1..n in
      DOM order; the section's go()/sync() and enso-pdp-roomfirst.js read
      data-go at click time, so they pick this up.
   2. Arrows loop (22 Sep pm, Mike: "once the scroll gets to the end ... it
      should go back to the first image"): next on the last image goes to the
      first, prev on the first goes to the last. A capture-phase document
      listener pre-empts the section's clamped go() only at the two ends and
      does a quick fade + jump rather than smooth-scrolling back through
      every slide.
      .has-arrows on .epc__stage (more than one image) shows both arrows
      (styles: snippets/enso-css-pdp-2.liquid, >=750px).
   3. The thumbnail strip keeps the active thumbnail centred, like the
      lightbox strip. It has no scrollbar, so past ~9 images the rest were
      unreachable with a mouse; now clicking or arrowing along reveals them.
   --------------------------------------------------------------------------- */
(function () {
  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }
  ready(function () {
    var track = document.getElementById('epcTrack');
    if (!track) return;
    var slides = track.querySelectorAll('.epc__slide');
    var n = slides.length;
    if (!n) return;
    var stage = track.closest ? track.closest('.epc__stage') : track.parentNode;
    var strip = document.querySelector('#epc .epc__thumbs');
    var thumbs = strip ? strip.querySelectorAll('.epc__thumb') : [];

    Array.prototype.forEach.call(slides, function (s, i) { s.setAttribute('data-i', String(i + 1)); });
    Array.prototype.forEach.call(thumbs, function (b, i) {
      b.setAttribute('data-go', String(i + 1));
      b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + n);
    });
    if (stage && n > 1) stage.classList.add('has-arrows');

    function index() {
      var w = track.clientWidth;
      return w ? Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w))) : 0;
    }
    function update() {
      var b = thumbs[index()];
      if (!b || !strip || !b.offsetWidth || strip.scrollWidth <= strip.clientWidth + 1) return;
      var sr = strip.getBoundingClientRect(), br = b.getBoundingClientRect();
      var left = br.left - sr.left + strip.scrollLeft - (strip.clientWidth - br.width) / 2;
      left = Math.max(0, Math.min(strip.scrollWidth - strip.clientWidth, left));
      if (Math.abs(left - strip.scrollLeft) > 4) strip.scrollTo({ left: left, behavior: 'smooth' });
    }
    document.addEventListener('click', function (e) {
      var a = e.target instanceof Element ? e.target.closest('#epcPrev, #epcNext') : null;
      if (!a || n < 2) return;
      var j = index() + (a.id === 'epcNext' ? 1 : -1);
      if (j >= 0 && j < n) return;              /* not at an end: the section's own handler runs */
      j = j < 0 ? n - 1 : 0;
      e.stopPropagation(); e.preventDefault();
      var x = slides[j].offsetLeft - track.offsetLeft;
      if (n < 3) { track.scrollTo({ left: x, behavior: 'smooth' }); return; }
      var im = slides[j].querySelector('img');
      if (im && im.loading === 'lazy') im.loading = 'eager';
      track.style.transition = 'opacity .16s ease'; track.style.opacity = '0';
      setTimeout(function () {
        track.scrollTo({ left: x, behavior: 'auto' }); track.style.opacity = '';
        setTimeout(function () { track.style.transition = ''; }, 220);
      }, 160);
    }, true);
    var t;
    function later() { clearTimeout(t); t = setTimeout(update, 90); }
    track.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later);
    update();

    /* 26 Sep: swiping to a slide that had not loaded yet (loading=lazy) showed a
       blank frame for ~0.5 s. Once the page has loaded, fetch the next two slides,
       and keep two ahead as the visitor swipes. */
    function warm() {
      var i = index();
      for (var k = i + 1; k <= i + 2 && k < n; k++) {
        var im = slides[k].querySelector('img');
        if (im && im.loading === 'lazy') im.loading = 'eager';
      }
    }
    if (document.readyState === 'complete') setTimeout(warm, 800);
    else window.addEventListener('load', function () { setTimeout(warm, 800); });
    track.addEventListener('scroll', warm, { passive: true });
  });
})();
